const Lineup = {
    LINEUP_SET_IS_CHECKED: 'LINEUP_SET_IS_CHECKED',
    LINEUP_REMOVE: 'LINEUP_REMOVE',

    LINEUPS_LIST_SET_IS_CHECKED: 'LINEUPS_LIST_SET_IS_CHECKED',
    LINEUPS_LIST_SET_SORT: 'LINEUPS_LIST_SET_SORT',
    LINEUPS_LIST_REMOVE_CHECKED: 'LINEUPS_LIST_REMOVE_CHECKED',

    SHOW_UNEXPOSED_PLAYERS_IN_EXPOSURE_BOX: 'SHOW_UNEXPOSED_PLAYERS_IN_EXPOSURE_BOX',
};

export default Lineup;
